import React, { useMemo, useState } from 'react';
import { styled, Typography } from '@mui/material';
import SettingSequenceSingleInput from './SettingSequenceSingleInput';
import DialogCloseSvgIcon from '../../../assets/svg/dialog/DialogCloseSvgIcon';

interface SettingSequenceInputProps {
  size: number;
  type: string;
  name: string;
  handleOnChange: (e: string[]) => void;
  handleCloseInputItem: (value: string) => void;
}

const Title = styled(Typography)(({ theme }) => ({
  ...theme.externalTypography.body3,
  color: theme.color.secondary.$60,
}));

const SettingSequenceInput: React.FC<SettingSequenceInputProps> = ({
  size,
  type,
  name,
  handleOnChange,
  handleCloseInputItem,
}) => {
  const [sequenceInputs, setSequenceInput] = useState<{
    name: string;
    value: string[];
  }>({ name: type, value: Array(size).fill('') });

  const handleInputChange = ({ e, index }) => {
    const temp = sequenceInputs.value;
    temp[index] = e;
    setSequenceInput((prev) => ({ ...prev, value: temp }));
  };

  const inputHTML = useMemo(() => {
    return sequenceInputs.value.map((d, index) => (
      <SettingSequenceSingleInput
        key={`${index} - ${d}`}
        index={index}
        handleOnChange={(e, index) => {
          handleInputChange({ e, index });
          handleOnChange(sequenceInputs.value);
        }}
        type={type}
      />
    ));
  }, [size, type]);

  return (
    <>
      <div
        className="container-input"
        style={{ display: 'flex', flexDirection: 'row' }}
      >
        <Title style={{ flex: '1', display: 'flex', alignItems: 'center' }}>
          {name}
        </Title>
        <DialogCloseSvgIcon
          className="button"
          onClick={() => handleCloseInputItem(name ?? '')}
          style={{ cursor: 'pointer' }}
        />
      </div>
      {inputHTML}
      {/* <pre>{JSON.stringify(sequenceInputs.value, null, 4)}</pre> */}
    </>
  );
};

export default SettingSequenceInput;
